import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import Tabulator from 'tabulator-tables';


@Component({
  selector: 'app-voucher-redeemed',
  templateUrl: './voucher-redeemed.component.html',
  styleUrls: ['./voucher-redeemed.component.less']
})
export class VoucherRedeemedComponent implements OnInit {
  private table: Tabulator;
  @Input() allUsers: any[];
  @Input() allVouchers: any[];

  public currentYear = new Date().getFullYear();
  public allYears: number[] = [];

  constructor(private active: NgbActiveModal, private adminServ: AdminService) { }

  ngOnInit() {
    this.init();
  }

  private init() {
    this.table = new Tabulator('#whoRedeemed', {
      responsiveLayout: 'collapse',
      pagination: 'local',
      paginationSize: 15,
      paginationSizeSelector: true,
      index: 'voucher_code',
      layout: 'fitColumns',
      columns: [
        { title: 'Voucher Code', field: 'voucher_code', width: 150, sorter: 'string' },
        { title: 'Person', field: 'name', sorter: 'string' },
        {
          title: 'Discount', field: 'discount', width: 150, sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let aDiscount = 0;
            let bDiscount = 0;

            aDiscount = Number(String(a).split('%')[0]);
            bDiscount = Number(String(b).split('%')[0]);

            return aDiscount - bDiscount;
          }
        },
        {
          title: 'Created', field: 'dateCreated', sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            const aDate = new Date(a).getTime();
            const bDate = new Date(b).getTime();
            return aDate - bDate;
          }
        },
        {
          title: 'Expires', field: 'dateExpired', sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            const aDate = new Date(a).getTime();
            const bDate = new Date(b).getTime();
            return aDate - bDate;
          }
        },

      ],
      // rowClick: (e, row) => {
      //   const data = row.getData();
      //   const newData = {
      //     from: 'users',
      //     data: data
      //   };

      //   // mouse click event
      //   this.loadModal(newData);
      // },
      // rowTap: (e, row) => {
      //   const data = row.getData();
      //   const newData = {
      //     from: 'users',
      //     data: data
      //   };

      //   // touch screen tap
      //   this.loadModal(newData);
      // }
    });


    for (let year = 2017; year <= this.currentYear; year++) {
      this.allYears.push(year);
    }

    this.allYears.sort((a, b) => {
      return b - a;
    });

    this.getAllRedeemed();
  }

  private getAllRedeemed() {
    const whoRedeemed = [];
    let tempVoucherOfYear = [];

    const finalWhoVoucher = [];

    tempVoucherOfYear = this.allVouchers.filter(voucher => {
      return new Date(voucher.date).getFullYear() === this.currentYear;
    });

    for (let al = 0; al < this.allUsers.length; al++) {
      if (typeof this.allUsers[al].subscription === 'string') {
        const subObject = JSON.parse(this.allUsers[al].subscription);

        if (subObject.hasOwnProperty('account') && subObject.account.hasOwnProperty('voucher_code')) {
          whoRedeemed.push({
            name: this.allUsers[al].name,
            voucher_code: subObject.account.voucher_code
          });
        }
      }
    }

    for (let vl = 0; vl < tempVoucherOfYear.length; vl++) {
      for (let w = 0; w < whoRedeemed.length; w++) {
        if (tempVoucherOfYear[vl].code === whoRedeemed[w].voucher_code) {
          finalWhoVoucher.push({
            name: whoRedeemed[w].name,
            voucher_code: whoRedeemed[w].voucher_code,
            discount: tempVoucherOfYear[vl].discount,
            dateCreated: tempVoucherOfYear[vl].date,
            dateExpired: tempVoucherOfYear[vl].expired
          });
        }
      }
    }

    this.updateTableRow(finalWhoVoucher);
  }

  public yearOfRedeem(year) {
    this.currentYear = Number(year);
    this.getAllRedeemed();
  }

  public searchTable(searchValue) {
    const filters = [];
    const columns = this.table.getColumns();

    columns.forEach(function (column) {
      filters.push({
        field: column.getField(),
        type: 'like',
        value: searchValue,
      });
    });

    this.table.setFilter([filters]);
  }

  private updateTableRow(rows) {
    this.table.replaceData(rows);
  }

  public closeModal() {
    this.active.close();
  }

}
